import { render, staticRenderFns } from "./MainOtp.vue?vue&type=template&id=71d74788&"
import script from "./MainOtp.vue?vue&type=script&lang=js&"
export * from "./MainOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports